export class ExternalCallTypeApiModel {
  public Id: string;
  public DateTime: Date;
  public CallTypeName: string;
  public IncidentNumber: string;
  public ActivityTypeId: string;
  public ActivityTypeName: string;
  public ActivityTypeIconNumber: number;
  public AlreadyImported?: boolean;
  public Location: string;

  public deserialize(data: Object): ExternalCallTypeApiModel {
    Object.assign(this, data);
    this.DateTime = new Date(this.DateTime);

    return this;
  }
}
